export const locales = {
	label: 'Retour'
};
